import {SELECT_TILE} from '../actions/actionTypes'

const selectedTile = (state = {}, action) =>{
	switch( action.type ){
		case SELECT_TILE:
			return action.id;
		default:
			return state;
	}
}

export default selectedTile;


// WEBPACK FOOTER //
// ./src/reducers/selectedTile.js